import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        variant: String,
        uppercase: Boolean,
        hover: Boolean,
    },
});
